import api from "./api";

export const getHubReport = async (hubId) => {
  const res = await api.get(`/report/hub/${hubId}`);
  const data = res.data?.data;
  if (!data) return null;
  if (data.events?.$values) data.events = data.events.$values;
  return data;
};